import React from "react";
import * as Font from "expo-font";
import AppLoading from "expo-app-loading";
import { Platform } from "react-native";
import { ScrollContext } from "../../hooks/useScrollLock";

function crossPlatformFontImport() {
  let fonts = {
    Vazir: require(`../../resources/fonts/Vazir.ttf`),
    "Vazir-Bold": require(`../../resources/fonts/Vazir-Bold.ttf`),
    "Vazir-Medium": require(`../../resources/fonts/Vazir-Medium.ttf`),
    "Vazir-Light": require(`../../resources/fonts/Vazir-Light.ttf`),
    icons: require(`../../resources/fonts/icons-font.ttf`),
  };

  return {
    Vazir: fonts.Vazir.default ?? fonts.Vazir,
    "Vazir-Bold": fonts["Vazir-Bold"].default ?? fonts["Vazir-Bold"],
    "Vazir-Medium": fonts["Vazir-Medium"].default ?? fonts["Vazir-Medium"],
    "Vazir-Light": fonts["Vazir-Light"].default ?? fonts["Vazir-Light"],
    icons: fonts.icons.default ?? fonts.icons,
  };
}

function loadFonts() {
  return Font.loadAsync(crossPlatformFontImport());
}

function Bootstrap(props: { children: React.ReactNode }) {
  let [fontLoaded, setLoaded] = React.useState(false);
  let [scrollStatus, setScrollStatus] = React.useState(false);

  React.useEffect(() => {
    loadFonts().then(() => {
      setLoaded(true);
    });
    if (Platform.OS === "web") {
      setLoaded(true);
    }
  }, []);

  if (!fontLoaded) return <AppLoading />;
  return (
    <ScrollContext.Provider
      value={{
        enabled: scrollStatus,
        setStatus: setScrollStatus,
      }}
    >
      {props.children}
    </ScrollContext.Provider>
  );
}

export default Bootstrap;
